import React from 'react';
import image from "./Page-Under-Construction.png";

function Rewards() {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Use viewport height to make it full-screen
        backgroundColor: '#f0f0f0', // Set a background color
    };

    const imageStyle = {
        maxWidth: '100%',
        maxHeight: '100%',
    };

    return (
        <div style={containerStyle}>
            {/*<h1>Under Construction</h1>*/}
            <img
                src={image}
                alt="Under Construction"
                style={imageStyle}
            />
            <h1>Coming Soon...</h1>
        </div>
    );
}

export default Rewards;
